export default __webpack_public_path__ + "static/media/psychiatric-icon.c0aaa07f.svg";